// extracted by mini-css-extract-plugin
module.exports = {"volumeIcon":"VolumeSettings_volumeIcon__AvVcg","volumeIconActive":"VolumeSettings_volumeIconActive__2B45Z"};